import { useForm } from "react-hook-form";
import RegisterNav from "./register/RegisterNav";
import "../../css/Home.css";
import Nav from "../../components/Nav";
import { Login } from "../../services/AuthService";
import useSignIn from "react-auth-kit/hooks/useSignIn";
import { useAxiosInstance } from "../../services/Interceptor";
import { toast } from "react-toastify";
import { Link, Navigate } from "react-router-dom";
import useIsAuthenticated from "react-auth-kit/hooks/useIsAuthenticated";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";

export default function SignIn({ color }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [showPassword, setShowPassword] = useState(false);
  const signIn = useSignIn();
  const apiInstance = useAxiosInstance();
  const isAuthenticated = useIsAuthenticated();
  const [searchParams] = useSearchParams();

  const handleLogin = async (formData) => {
    const credentials = { email: formData.email, password: formData.password };

    if (credentials.password.length < 6) {
      toast.error("Invalid credentials. Please check your email or password.");
      return;
    }

    try {
      const data = await Login(apiInstance, credentials);

      if (!data || !data.user || !data.user.role) {
        toast.error(
          "Invalid credentials. Please check your email or password.",
        );
        return;
      }

      const role = data.user.role;
      if (data.verifyGuid) {
        localStorage.setItem("_auth_verify_guid", data.verifyGuid);
      }

      const isAuthenticated = signIn({
        auth: {
          token: data.accessToken,
          type: "Bearer",
        },
        expiresIn: 3600,
        userState: { user: data.user },
        refresh: data.refreshToken,
      });

      if (isAuthenticated) {
        if (role === "athlete") {
          window.location.href = "/athlete/dashboard";
        } else {
          const roleRedirects = {
            admin: "/admin/dashboard",
            university: "/university/dashboard",
          };

          if (searchParams.size > 0 && searchParams.get("back-to-profile")) {
            window.location.href = `/${role}/athlete-profile/${searchParams.get("profile")}`;
          } else {
            const redirect_url = roleRedirects[role];
            if (redirect_url) {
              window.location.href = redirect_url;
            } else {
              toast.error("Unknown role. Please contact support.");
            }
          }
        }
      } else {
        toast.error("Login failed. Please try again.");
      }
    } catch (error) {
      console.error("Error during login:", error);
      const errorMessage =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : "Invalid Email or Password.";

      toast.error(errorMessage);
    }
  };

  return (
    <>
      {isAuthenticated && <Navigate to="/" />}
      <Nav />
      <div className="flex items-center justify-center pt-14">
        <div className="w-full max-w-4xl p-0">
          <RegisterNav />
          <form
            onSubmit={handleSubmit(handleLogin)}
            className="container mx-auto px-4"
          >
            <div className="px-2 mb-20">
              <div className="form-field mt-4">
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  type="email"
                  aria-invalid={errors.email ? "true" : "false"}
                  name="email"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                      message: "Invalid email format",
                    },
                  })}
                  placeholder="Enter your email"
                />
                {errors.email && (
                  <p className="text-red-500">{errors.email.message}</p>
                )}
              </div>
              <div className="form-field w-full mt-4">
                <label htmlFor="password">Password</label>
                <div className="relative flex items-center">
                  <input
                    id="password"
                    type={showPassword ? "text" : "password"}
                    aria-invalid={errors.password ? "true" : "false"}
                    name="password"
                    {...register("password", {
                      required: "Password is required",
                    })}
                    placeholder="Enter your password"
                    className="w-full pr-10 border rounded px-3 py-2"
                  />
                  <FontAwesomeIcon
                    icon={showPassword ? faEyeSlash : faEye}
                    aria-label="toggle password visibility"
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-600"
                    onClick={() => setShowPassword(!showPassword)}
                  />
                </div>
                {errors.password && (
                  <p className="text-red-500">{errors.password.message}</p>
                )}
              </div>
              <div className="flex justify-between mt-6">
                <button
                  type="submit"
                  className="bgroup text-white bg-red-500 font-medium px-8 py-2 rounded-full text-lg hover:bg-red-500/70 transition"
                >
                  Sign In
                  <span className="inline-block transition-transform duration-300 group-hover:translate-x-1 ">
                    →
                  </span>
                </button>
                <Link
                  className="text-red-500 hover:underline cursor-pointer uppercase"
                  to="/forgot-password"
                >
                  Forgot Password?
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
